import { Skeleton, Stack } from '@mui/material';
import { COMMON } from '../../../constants/style';
import { StringUtility } from '../../../utils/StringUtility';
import VegaText from '../../common/VegaText';
import { IPosAmountsProps } from '../CollectedVsCollectabelContainer';

const RollForwardAndAmountDue = ({ posAmounts, loading }: IPosAmountsProps) => {
  return (
    <>
      <Stack
        direction={'row'}
        justifyContent={'space-between'}
        alignItems={'center'}
        sx={{
          p: 3,
          bgcolor: 'white',
          borderRadius: '12px',
          boxShadow: 'rgba(100, 100, 111, 0.2) 0px 0px 7px 0px',
        }}
      >
        <Stack gap={2}>
          {loading ? (
            <Skeleton />
          ) : (
            <VegaText
              text={
                posAmounts.length
                  ? `${getAmountValue(
                      posAmounts[0]?.ROLL_FORWARD_POS
                    )} (in Crores)`
                  : 0
              }
              fontSize={17}
              fontWeight={600}
              color={COMMON.balck}
            />
          )}
          <VegaText
            text={'Roll Forward'}
            fontSize={17}
            fontWeight={600}
            color={COMMON.balck}
          />
        </Stack>
        <Stack gap={2}>
          {loading ? (
            <Skeleton />
          ) : (
            <VegaText
              text={
                posAmounts.length
                  ? `${getAmountValue(
                      posAmounts[0]?.OVERDUE_AMOUNT
                    )} (in Crores)`
                  : 0
              }
              fontSize={17}
              fontWeight={600}
              color={COMMON.balck}
            />
          )}
          <VegaText
            text={'Amount Due'}
            fontSize={17}
            fontWeight={600}
            color={COMMON.balck}
          />
        </Stack>
      </Stack>
    </>
  );
};

export default RollForwardAndAmountDue;

const getAmountValue = (posAmount: string) => {
  if (posAmount) {
    const value =
      typeof posAmount === 'string' ? parseFloat(posAmount) : posAmount;
    if (!isNaN(value)) {
      var numberInCrores = value / 1e7;
      return numberInCrores.toFixed(2);
    } else {
      return 0;
    }
  } else {
    return StringUtility.formatToINR(0);
  }
};
